import * as functions from '@/assets/js/Functions';
import {
    addEventListener,
    after,
    ajax,
    each,
    hasClass,
    isDefinedAndNotEmpty,
    isGlobalVariableDefined
} from '@/assets/js/Functions';
import Fingerprint2 from '@/assets/js/vendor/fingerprint2.min';
import {tns} from "@/assets/js/vendor/tiny-slider"
import {createApp, guardReactiveProps} from "vue";
import OfferCards from "@/components/OfferCards.vue";

const searchParams = new URLSearchParams(window.location.search)
window.tns = tns

Fingerprint2.get({
    excludes: {
        deviceMemory: true,
        enumerateDevices: true,
    }
}, function (components) {
    const fingerprint = Fingerprint2.x64hash128(components.map(function (component) { return component.value }).join(''), 31);
    localStorage.setItem('fingerprint', fingerprint);
})

const redirectElement = document.querySelector('.redirect');
botRegisterVisit();


if (redirectElement) {
    const loader = redirectElement.querySelector('.loader span');
    const timeText = redirectElement.querySelector('.countdown .num');
    let time = parseInt(redirectElement.getAttribute('data-time'), 10);
    const redirectUrl = redirectElement.getAttribute('data-url');

    // Анимация loader'а
    loader.style.width = '100%';
    loader.style.transition = `width ${time * 1000}ms linear`;

    // Функция обратного отсчета
    function tick() {
        if (time > 1) {
            timeText.textContent = --time;
            setTimeout(tick, 1000);
        } else {
            window.location.href = redirectUrl;
        }
    }
    // Запускаем отсчет
    setTimeout(tick, 1000);
}

// Если есть GET параметр CID - выполянем цель DOI done
if(searchParams.get('cid')){
    reachTargets(null, ['target_goal_doi_done'])
}

// Welcome Request
if(!functions.getCookie('wr_send')){
    let ga_client_id = functions.getCookie('_ga');
    if (ga_client_id) ga_client_id = ga_client_id.split('GA1.2.')[1]
    functions.ajax({
        action: 'offers_page_request',
        fingerprint: localStorage.getItem('fingerprint'),
        ym_user_id: functions.getCookie('_ym_uid'),
        ga_client_id: ga_client_id
    })
}
functions.addEventListener('click', '#cookie_accept', (e, element)=>{
    e.preventDefault();
    functions.slideUp('.cookie_accept', 500)
})
functions.addEventListener('click', '[data-target], [data-href]', (e, element)=>{

    if(functions.attr(element, 'data-target')){
        reachTargets(element, functions.attr(element, 'data-target'))
    }

    if (!functions.attr(element, 'href')) e.preventDefault()

    if(functions.hasClass(element, 'comeback') && ajax_data.comeback){
        window.setTimeout(function() {
            const redirectUrl = new URL(ajax_data.comeback_page);
            redirectUrl.searchParams.append('cmb', 1);
            window.open(redirectUrl, '_self');
        }, parseInt(ajax_data.comeback_delay) * 1000);
    }

    if (functions.attr(element, 'data-href')) {
        window.open(functions.data(element, 'href'), '_blank');
    }
})

// Аккордеон
functions.addEventListener('click', '.accordion li:not(.active)', (e, element)=>{
    e.preventDefault()
    e.stopPropagation()
    functions.each('.accordion li',  (element)=>{
        functions.removeClass(element, 'active')
    })
    functions.addClass(element, 'active')
})

// Сворачивающися текст
functions.addEventListener('click', '.read_more', (e, element)=>{
    e.preventDefault()
    e.stopPropagation()
    let parent = functions.parent(element)
    functions.addClass(parent, 'expand')
})

// Сворачивание текста
functions.each('.collapsed.cut', (element) => {
    if(element.height < 500) return
    functions.addClass(element, 'cut')
    let expandButton = document.createElement('button')
    functions.addClass(expandButton, 'expand')
    expandButton.innerHTML =  ajax_data.expand_text
    functions.after(expandButton, element)
})

// Развертывание и свертывание текста
functions.addEventListener('click', 'button.expand', (e, button)=>{
    e.preventDefault()
    let text = functions.prev(button)
    if (!text) return
    functions.toggleClass(text, 'cut')
    button.innerHTML = ajax_data.collapse_text
})

// Скролл к якорному элементу
functions.addEventListener('click', 'a.scroll', (e, element)=> {
    e.preventDefault()
    let anchor = functions.attr(element, 'href')
    anchor = document.querySelector(anchor)
    if (!anchor) return
    anchor.scrollIntoView({ behavior: 'smooth' });
})

// Блок отзывов
functions.each('section.reviews .reviews', (element) => {
    tns({
        container: element,
        items: 2,
        edgePadding: 40,
        swipeAngle: 25,
        speed: 400,
        mouseDrag: true,
        loop: false,
        nav: false,
        controls: false,
        responsive:{
            0:{
                items:1,
            },
            1024:{
                items:2,
            }
        },
        prevButton : 'section.reviews .arrows .prev',
        nextButton : 'section.reviews .arrows .next',
    });
})

// Всплыващие карточки офферов
functions.elementExists('.offers', (response) => {
    if(!functions.isDefinedAndNotEmpty(window.offers)) return
    let cards = []
    let index = 0
    each('.offers .offer', (offer) => {

        if(window.offers.auto_popup === '1'){
            if(index > 1) return
        }else {
            if(!functions.data(offer, 'toast') || functions.data(offer, 'toast') !== '1' || functions.data(offer, 'double') === '1') return
        }
        cards.push({
            head:  functions.find(offer, '.head')[0].outerHTML,
            button: functions.find(offer, 'a.get_money')[0].outerHTML,
            text: functions.find(offer, '.promotion')[0].outerHTML,
            visible: false
        })
        index++
    })

    if (cards.length > 0) {
        let cardsHolder = document.createElement('div')
        cardsHolder.id = 'OfferCards'
        document.querySelector('body').appendChild(cardsHolder)
        createApp(OfferCards,{
            cards: cards,
            params: {
                delay: !isNaN(parseInt(window.offers.cards_delay)) ? parseInt(window.offers.cards_delay) : 5
            }
        }).mount(cardsHolder)
    }
})

addEventListener('click', '.spoiler', (e, element) => {
    e.preventDefault()
    functions.toggleClass(element, 'active')
})

// Добавляем кнопку показать еще у офферов на витрине
functions.elementExists('.offers', (response) => {
    if(!functions.isDefinedAndNotEmpty(window.offers)) return
    if(window.offers.offers_hider !== "1") return

    let showMoreButton = document.createElement('button')
    showMoreButton.textContent = window.offers.offers_hider_button
    showMoreButton.id = 'load_more';

    let container = document.querySelector('body .offers:last-child')
    if (!container) container = document.querySelector('body .offers')
    let visibleOffers = parseInt(window.offers.offers_hider_count)
    let step = parseInt(window.offers.offers_hider_count)
    if (!visibleOffers || !step) return

    container.appendChild(showMoreButton)
    function toggleOffersVisible(){
        let offers = functions.find(container, '.offer')
        offers.forEach(function(element, index) {

            if(index < visibleOffers){
                functions.removeClass(element, 'hidden')
            }else{
                functions.addClass(element, 'hidden')
            }
        })
        showMoreButton.style.display = (visibleOffers < offers.length ? 'block' : 'none')
    }

    showMoreButton.addEventListener('click', function () {
        visibleOffers += step
        toggleOffersVisible()
    })

    toggleOffersVisible()

})

functions.elementExists('.offers .offer .message', (response) => {
    window.addEventListener('load', () => processMessages('.offers .offer .message:not(.answered)'));
    window.addEventListener('scroll', () => processMessages('.offers .offer .message:not(.answered)'));
})

functions.elementExists('.offers .offer', (response) => {
    window.addEventListener('load', () => checkVisible('.offers .offer:not(.hidden):not(.viewed)'));
    window.addEventListener('scroll', () => checkVisible('.offers .offer:not(.hidden):not(.viewed)'));
})

functions.addEventListener('click', '.offers .offer .offer_button', (e, element) => {

    let id = parseInt(functions.data(element, 'id'))
    let rid = parseInt(functions.data(element, 'rid'))
    let fingerPrint = localStorage.getItem('fingerprint')
    let offerPosition = functions.index(functions.closest(element, '.offer'), 'offer', true)
    let parent = functions.parent(element, 'div.offer')
    let nextOffer = functions.next(parent)
    let needScroll = !functions.hasClass(parent, 'tns-item')
    let modalSettings = sessionStorage.getItem('questionModal')
    if(modalSettings && sessionStorage.getItem('VisitOffer') !== '0') needScroll = false

    functions.addClass(parent, 'visited')

    if(needScroll && nextOffer) nextOffer.scrollIntoView({ behavior: 'smooth' })

    // Отправка данных о клике на оффер в БОТ
    ajax({
        action : 'update_offer_clicks',
        offerId: id,
        offerRid: rid,
        fingerprint: fingerPrint,
        offerPosition: offerPosition
    })

    // Отправка данных о клике на оффер в CRM
    ajax({
        action : 'update_clicked_offers',
        offer_id: rid,
        fingerprint: fingerPrint,
    })
})

// Достижение целей
function reachTargets(element, targets = []){
    let targetArray = targets
    if(!targets) targetArray = functions.data(element, 'target')
    if(!targetArray) return null

    targetArray = ajax_data.targets[targetArray];
    if(!targetArray) return null

    Object.entries(targetArray).forEach(([key, value]) => {
        if(value !== '') functions.reachTarget (value, key)
    });
}

// Регистрация визита в отчете для Телеграм бота
function botRegisterVisit(){
    let pageTemplate = false;
    if(functions.hasClass('#content', 'reg_page')) pageTemplate = 'tpl_registration';
    if(functions.hasClass('#content', 'showcase')) pageTemplate = 'tpl_showcase';
    if(!pageTemplate) return;

    functions.ajax({
        action: 'bot_register_page_visit',
        template: pageTemplate,
    })
}

// Функция для перемешивания массива (алгоритм Fisher-Yates)
function shuffleArray(array) {

    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

// Получение списка ответов от кредиторов
function getCreditAnswers() {
    const creditAnswersKey = 'creditAnswers'
    let creditAnswers = localStorage.getItem(creditAnswersKey)

    if (creditAnswers) {
        return Promise.resolve(JSON.parse(creditAnswers))
    } else {
        return new Promise((resolve, reject) => {
            functions.ajax({ action: 'get_credit_answers' }, (data) => {
                if(!data) return
                shuffleArray(data)
                localStorage.setItem(creditAnswersKey, JSON.stringify(data))
                resolve(data)
            });
        });
    }
}

// Добавление ответов о  кредиторов к офферам
function processMessages(selector) {
    getCreditAnswers().then(answers => {
        if(!answers.length) return
        if(!window.offers) return
        functions.each(selector, (element) => {
            if(!functions.isInViewport(element)) return
            const randomTime = Math.floor(Math.random() * (1500 - 700 + 1)) + 700
            const answerToAssign = answers[Math.floor(Math.random() * answers.length)]
            setTimeout(() => {
                element.innerHTML = '<p class="response"><span>' + offers.response_text + '</span> ' + answerToAssign + '</p>'
            }, randomTime)
            functions.addClass(element, 'answered')
        });
    });
}

// Отмечаем что оффер был показан
function checkVisible(selector){
    functions.each(selector, (element) => {
        if(functions.isInViewport(element) && !hasClass(element, 'viewed')){
            let id = parseInt(functions.data(element, 'id'))
            let rid = parseInt(functions.data(element, 'rid'))
            let fingerPrint = localStorage.getItem('fingerprint')
            let offerPosition = functions.index(functions.closest(element, '.offer'), 'offer', true)
            functions.addClass(element, 'viewed')
            functions.ajax({
                action: 'register_viewed_offers',
                offer: id,
                offerRid: rid,
                fingerprint: fingerPrint,
                offerPosition: offerPosition
            })
        }
    })

}